export default "__VITE_ASSET__DM1zU2iL__"